import { motion } from "framer-motion";
import { SUSTAINABILITY } from "@/lib/site-data";
import { Leaf } from "lucide-react";

const BG = "https://images.unsplash.com/photo-1592492152545-9695d3f473f4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxtb2x0ZW4lMjBnb2xkJTIwbGlxdWlkfGVufDB8fHx8MTc4MTg2NDU4MXww&ixlib=rb-4.1.0&q=85";

export default function Sustainability() {
  return (
    <section data-testid="sustainability-section" id="sustainability" className="relative py-24 lg:py-32 overflow-hidden bg-white">
      <div
        className="absolute inset-0 -z-10 opacity-25"
        style={{ backgroundImage: `url(${BG})`, backgroundSize: "cover", backgroundPosition: "center", backgroundAttachment: "fixed" }}
      />
      <div className="absolute inset-0 -z-10 bg-white/85" />
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="text-[11px] uppercase tracking-[0.22em] text-[#D4AF37] font-semibold">Sustainability</div>
            <h2 className="font-heading mt-3 text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight">
              Refined with <span className="gold-gradient-text font-medium">responsibility</span>.
            </h2>
            <p className="mt-5 text-[#4B5563] text-base leading-relaxed">
              We treat sustainability as a core operating principle — not a marketing line. Every gram refined at
              Agroya is processed under verified, traceable, environmentally compliant workflows.
            </p>
          </div>
          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4">
            {SUSTAINABILITY.map((s, i) => (
              <motion.div
                key={s.title}
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.05 }}
                data-testid={`sustain-${i}`}
                className="p-5 bg-white/80 backdrop-blur-sm border border-[#E5E5E5] rounded-lg lift-card"
              >
                <Leaf className="w-5 h-5 text-[#D4AF37] mb-3" strokeWidth={1.5} />
                <div className="font-heading text-base font-medium text-[#0A0A0A]">{s.title}</div>
                <div className="mt-1.5 text-sm text-[#4B5563] leading-relaxed">{s.desc}</div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
